import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateFieldCustomValue, privateFieldCustomValuesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const PRIVATE_FIELD_CUSTOM_VALUE_MODULE = 'privateFieldCustomValue';

const dataObjectModule = getDataObjectsModule<IPrivateFieldCustomValue>(privateFieldCustomValuesManager, 1);
const searchModule = getSearchModule<IPrivateFieldCustomValue>(privateFieldCustomValuesManager);

const privateFieldCustomValuesModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(PRIVATE_FIELD_CUSTOM_VALUE_MODULE, privateFieldCustomValuesModuleInstance);

export { PRIVATE_FIELD_CUSTOM_VALUE_MODULE };
